import "./index.css"

import { jsx } from 'react/jsx-runtime';
import { Button } from '@design-system/button';
import { RTEText } from '@design-system/rte-text';
import UITooltip from '@phx-husky/tooltip';
import classNames from 'classnames';
import { forwardRef } from 'react';

const Tooltip = forwardRef(({ className, tooltipWindowClassName, portalQuerySelector, label, text, content, isTooltipContentInteractive = false, icon = 'tooltip', onClickTooltip, onBlurTooltip, }, ref) => (jsx("div", Object.assign({ ref: ref, className: classNames('cds-tooltip', className) }, { children: jsx(UITooltip, Object.assign({ placement: "top-end", className: classNames('cds-tooltip-window', tooltipWindowClassName), title: text && jsx(RTEText, { text: text }) }, { content, isTooltipContentInteractive, portalQuerySelector }, { children: jsx(Button, Object.assign({ variant: "subtle-icon", iconPrefix: { props: { icon } }, className: "cds-tooltip__button", onClick: onClickTooltip, onBlur: onBlurTooltip }, { children: label })) })) }))));

export { Tooltip };
